var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0ZM8.45 9.75C8.45 9.15248 8.56769 8.56082 8.79635 8.00879C9.02501 7.45676 9.36016 6.95517 9.78266 6.53266C10.2052 6.11016 10.7068 5.77501 11.2588 5.54635C11.8108 5.31769 12.4025 5.2 13 5.2C13.5975 5.2 14.1892 5.31769 14.7412 5.54635C15.2932 5.77501 15.7948 6.11016 16.2173 6.53266C16.6398 6.95517 16.975 7.45676 17.2037 8.00879C17.4323 8.56082 17.55 9.15248 17.55 9.75C17.55 10.9567 17.0706 12.114 16.2173 12.9673C15.364 13.8206 14.2067 14.3 13 14.3C11.7933 14.3 10.636 13.8206 9.78266 12.9673C8.92937 12.114 8.45 10.9567 8.45 9.75ZM21.1354 19.4792C20.1623 20.7033 18.9251 21.6917 17.5164 22.3707C16.1077 23.0496 14.5638 23.4015 13 23.4C11.4362 23.4015 9.8923 23.0496 8.48358 22.3707C7.07486 21.6917 5.83773 20.7033 4.8646 19.4792C6.9719 17.9673 9.8475 16.9 13 16.9C16.1525 16.9 19.0281 17.9673 21.1354 19.4792Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.e8c8581dadb048fb2e03bc779ad64743.svg";
export { ForwardRef as ReactComponent };